import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios';
import { CancelNegotiationValidationSchema } from '../schemas/cancelNegotiation.schema';

interface UseCancelNegotiationProps {
  id?: string
  onSuccess: (response: AxiosResponse) => void
  onError: (error: ErrorResponse) => void
}

export const useCancelNegotiation = ({
  id,
  onSuccess,
  onError,
}: UseCancelNegotiationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['cancelNegotiation', id],
    mutationFn: (formCancelNegotiation: CancelNegotiationValidationSchema) => {
      const payload = {
        cancel_reason: formCancelNegotiation.cancel_reason,
      };

      return privateAxios.put(`/negotiations/${id}/cancel`, payload);
    },
    onSuccess,
    onError,
  })
}
